"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHasuraRoleFromToken = void 0;
const jose_1 = require("jose");
const enums_1 = require("./enums");
function isHasuraRole(role) {
    for (const [, value] of Object.entries(enums_1.HasuraRoles)) {
        if (value === role) {
            return true;
        }
    }
    return false;
}
const getHasuraRoleFromToken = (token) => {
    const payload = (0, jose_1.decodeJwt)(token);
    const hasuraClaims = payload["https://hasura.io/jwt/claims"];
    const hasuraRole = hasuraClaims["x-hasura-default-role"];
    return isHasuraRole(hasuraRole) ? hasuraRole : undefined;
};
exports.getHasuraRoleFromToken = getHasuraRoleFromToken;
//# sourceMappingURL=getHasuraRoleFromToken.js.map